import React, { Fragment, useContext, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { UserContext } from "../UserContext";
import { hasAnyPerm } from '../utils/uiUtils';
//import CalConfigAdminListView    from "./CalConfigAdminListView";
import CalConfigAdminDetailsView from "./CalConfigAdminDetailsView";
//import CalConfigAdminNewView     from "./CalConfigAdminNewView";


const CalConfigAdmin = () => {

  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  // Initialize state
  useEffect(() => {

    // Route to home page if not authorized
    if (!hasAnyPerm(user, ["SystemAdminFullAccess", "PlatformAdminWriteAccess"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <Fragment>

      <CalConfigAdminDetailsView />

    </Fragment>
  )
}

export default CalConfigAdmin;
